import { useEffect, type RefObject } from 'react';

export interface UseInfiniteScrollSentinelOptions {
    scrollRootRef: RefObject<HTMLElement | null>;
    enabled: boolean;
    hasMore: boolean;
    isLoading: boolean;
    isLoadingMore: boolean;
    onLoadMore: () => void;
    threshold?: number;
}

export function useInfiniteScrollSentinel({
    scrollRootRef,
    enabled,
    hasMore,
    isLoading,
    isLoadingMore,
    onLoadMore,
    threshold = 240,
}: UseInfiniteScrollSentinelOptions) {
    useEffect(() => {
        const scrollRoot = scrollRootRef.current;
        if (!enabled || !scrollRoot || !hasMore || isLoading || isLoadingMore) return;

        const loadMore = () => {
            const root = scrollRootRef.current;

            if (!root) return;

            const remaining = root.scrollHeight - root.scrollTop - root.clientHeight;
            if (remaining <= threshold) {
                onLoadMore();
            }
        };

        scrollRoot.addEventListener('scroll', loadMore, { passive: true });
        return () => scrollRoot.removeEventListener('scroll', loadMore);
    }, [enabled, hasMore, isLoading, isLoadingMore, onLoadMore, threshold, scrollRootRef]);
}
